<i18n>
{
	"en": {
		"title" : "Create inbound EDI Setup",
		"endpoint" : "Destination",
		"sender" : "Sender",
		"recipient" : "Recipient",
		"messageFormatDescription" : "Message Format",
		"messageTypeDescription" : "Message Type",
		"ediMessageTransportMethod" : "Sending method",
		"notifyEdipartSetupCreated" : "EDI part setup was created successfully"
	},
	"no":{
		"title" : "Opprett inngående EDI oppsett",
		"endpoint" : "Destinasjon",
		"sender" : "Sender",
		"recipient" : "Mottaker",
		"messageFormatDescription" : "Meldings Format",
		"messageTypeDescription" : "Meldings Type",
		"ediMessageTransportMethod" : "Sendingsmetode",
		"notifyEdipartSetupCreated" : "EDI part setup ble opprettet"
	}
}
</i18n>

<template>
	<t-dialog
		:title="$t('title')"
		:isShown="isDialogShown"
		:icon="'settings'"
		iconType="bp"
		@close="close"
		@ok="add"
		@cancel="close"
	>
		<InboundSettings
			:inboundEdiSetting="inboundEdiSetting"
		/>
	</t-dialog>
</template>

<script>

import { mapGetters, mapActions } from '../store/details/ediSetupDetails.store';
import InboundSettings from '../editEdipart/InboundSettings';
import { v4 as uuid } from 'uuid';
export default {
	components: { InboundSettings },
	props: { isDialogShown: Boolean, },

	data() {
		return {
			inboundEdiSetting: {
				ssl:false,
				id: null,
				edipartId: null,
				sender:'',
				endpoint:'',
				recipient:'',
				createDate:'',
				description:null,
				messageType:1,
				allowUpdates:false,
				messageFormat:4,
				testMode: false,
				senderQualifier:'',
				transportMethod:3,
				endpointPassword:'',
				endpointUsername:'',
				recipientQualifier:'',
				messageTypeDescription:'Instruction',
				messageFormatDescription:'Timpex XML',
				transportMethodDescription:''
			}
		};
	},
	computed: { ...mapGetters(['edipart']) },
	methods:{
		...mapActions(['executeAddInboundSettingAndPatch']),
		close() {
			this.$emit('close');
		},
		add() {
			this.inboundEdiSetting.id = uuid();
			this.inboundEdiSetting.edipartId = this.edipart.id;
			this.executeAddInboundSettingAndPatch(this.inboundEdiSetting);
			this.$notify({
				type: 'success',
				title: this.$t('notifyEdipartSetupCreated')
			});
		},
	}
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	@import '~@/components/evergreen/scss/text';
.details{
	display: grid;
	grid-template-columns: repeat(4, minmax(220px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}

.transport-method-grid{
	display:grid;
	grid-template-columns: 100px;
}

hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
	}
</style>